import "./ChatLoaderComponent.scss";
import { useEffect, useState, useMemo } from "react";

interface ChatLoaderComponentProps {
    type: "requirement-step" | "chat-step" | "on-boarding-step" | "pm-step"
    className?: string
}

const onBoardingMessages = [
    "Saving your role...",
]

const chatMessages = [
    "Analyzing your prompt...",
    "Generating code...",
    "Almost ready...",
    "Fine-tuning the details...",
    "Double-checking for accuracy...",
    "Preparing your output...",
    "Just a moment..."
];

const pmMessages = [
    "Analyzing your requirements...",
    "Preparing your output...",
    "Just a moment..."
];

const ChatLoaderComponent = (props: ChatLoaderComponentProps) => {

    const { type, className } = props;

    // Memoize messages based on type to avoid recalculating on every render
    const messages = useMemo(() => {
        return type === "requirement-step" ? [] :
            type === "on-boarding-step" ? onBoardingMessages :
                type === "chat-step" ? chatMessages :
                    type === "pm-step" ? pmMessages :
                        pmMessages;
    }, [type]);

    const [messageIndex, setMessageIndex] = useState<number>(0);

    useEffect(() => {
        // Set interval to rotate messages
        const interval = setInterval(() => {
            setMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
        }, 2000); // Change message every 2 seconds

        // Clear interval on component unmount
        return () => clearInterval(interval);
    }, [messages]);

    return (
        <div className={`dot-pulsing-loader ${className}`}>
            <div className="dot-pulses">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
            </div>
            <span className="loading-text">{messages[messageIndex]}</span>
        </div>
    );

};

export default ChatLoaderComponent;
